<template>
  <hm-content title="">
    <div class="add-goods-containers">
      <hm-step
              :steps="steps"
              :scroll="true"
              :step="currentStep"
              @scroll="windowScroll"
      ></hm-step>
      <el-scrollbar :style="{ height: scrollHeight + 'px' }">
        <div class="pvw flex flex-warp">
          <div class="flex-4">
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="140px"
            >
              <div id="base">1.基本信息</div>
              <el-form-item label="活动标题" prop="gameName">
                <el-input
                        maxlength="25"
                        style="width: 400px"
                        size="small"
                        clearable
                        class="mr10 ipt"
                        v-model.trim="ruleForm.gameName"
                        placeholder="请输入活动标题"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动时间段选择" prop="activityDate">
                <!--el-date-picker
                        :default-time="['00:00:00', '23:59:59']"
                        v-model="ruleForm.activityDate"
                        :picker-options="pickerOptions"
                        type="datetimerange"
                        align="right"
                        start-placeholder="活动开始时间"
                        end-placeholder="活动结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="small"
                        class="mr10"
                ></el-date-picker -->
                <div>
                  开始时间：
                  <el-date-picker
                          disabled
                          v-model="ruleForm.activityDate[0]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['00:00:00', '23:59:59']"
                          placeholder="开始时间"
                          size="small"
                          class="mr10"
                  >
                  </el-date-picker>
                </div>
                <div>
                  结束时间：
                  <el-date-picker
                          size="small"
                          :editable="false"
                          v-model="ruleForm.activityDate[1]"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="'23:59:59'"
                          placeholder="结束时间"
                          :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="活动分享文案" prop="gameShareContent">
                <el-input
                        :maxlength="30"
                        style="width: 400px"
                        size="small"
                        clearable
                        class="mr10 ipt"
                        v-model.trim="ruleForm.gameShareContent"
                        placeholder="请输入活动分享文案，30字以内"
                ></el-input>
              </el-form-item>
              <el-form-item label="背景音乐链接" prop="gameBgm">
                <el-input
                        style="width: 400px"
                        size="small"
                        clearable
                        class="mr10 ipt"
                        v-model="ruleForm.gameBgm"
                        placeholder="请输入音乐链接/音乐网络地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="主图：" prop="mainImgUrl">
                <my-upload
                        field="file"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        v-if="show"
                        noCircle
                        noSquare
                        :width="750"
                        :height="360"
                        :headers="{ 'X-Access-Token': $token }"
                        :params="{ fileDir: 'mallDecoration' }"
                        :url="$uploadUrl"
                        img-format="png"
                ></my-upload>
                <!-- <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                noCircle
                noSquare
                :params="{ fileDir: 'mallDecoration' }"
                :headers="{ 'X-Access-Token': $token }"
                :width="750"
                :height="1334"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload> -->
                <el-button
                        type="primary"
                        size="small"
                        v-show="!listHeaderImgUrl"
                        @click="toggleShow"
                >上传</el-button
                >
                <span class="form-tip"
                >图片尺寸建议750x360（最多上传一张）</span
                >
                <div class="priview" v-if="listHeaderImgUrl">
                  <img :src="listHeaderImgUrl" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="handleRemove"
                    >删除</el-button
                    >
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="分享图：">
                  <el-upload
                    class="upload flex"
                    ref="eluploadMainPic"
                    :limit="1"
                    drag
                    :data="{ fileDir: 'mall' }"
                    :headers="{ 'X-Access-Token': $token }"
                    :action="$uploadUrl"
                    :onSuccess="uploadSharePicSucc"
                    :beforeUpload="beforeUpload"
                    :onProgress="uploading"
                    :show-file-list="uploadShow"
                    v-if="!ruleForm.sharePic"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将图片拖到此处，或
                      <em>点击上传</em>
                    </div>
                    <div class="el-upload__tip" slot="tip">
                      <div class="ml10">
                        上传图片注意：
                        <div>
                          1.分享图仅可设置一张
                        </div>
                        <div>
                          2.图片尺寸建议500x400
                        </div>
                      </div>
                    </div>
                  </el-upload>
                  <div class="priview priviewSharePic" v-if="ruleForm.sharePic">
                    <img :src="ruleForm.sharePic" alt="分享图" />
                    <div class="opreat-wrapper flex item-center flex-center">
                      <el-button type="text" @click="handleRemoveSharePic">删除</el-button>
                    </div>
                  </div>
              </el-form-item>
              <el-form-item label="活动规则说明" prop="gameRuleRemark">
                <hm-rich-editor
                        v-model="ruleForm.gameRuleRemark"
                        :html="ruleForm.gameRuleRemark"
                />
              </el-form-item>

              <el-form-item label="虚拟参与人数" prop="visualJoinNum">
                <span>在实际参与人数基础上增加</span
                ><el-input
                      type="number"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="ruleForm.visualJoinNum"
                      placeholder="请输入数字"
              ></el-input
              >人
              </el-form-item>
              <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>
              <el-form-item label="砍价类型" prop="bargainType">
                <el-tooltip
                        class="item"
                        effect="dark"
                        content="指定人数砍价后才可购买，是常发起砍价后必须达到指定人数，且指定人数后直接砍到底价购买;
                  随机价格区间欧价后即可购买是指只要砍价后，发起人可以随时进行购买; "
                        placement="top"
                >
                  <el-select
                          :disabled="ruleForm.updateMode === 'no'"
                          clearable
                          class="mr10 "
                          size="small"
                          v-model="bargainType"
                          placeholder="请选择砍价类型"
                  >
                    <el-option
                            label="指定人数砍价后才可购买"
                            value="people"
                    ></el-option>
                    <el-option
                            label="随机价格区间砍价后既可购买"
                            value="amount"
                    ></el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>

              <el-form-item label="添加商品" prop="drawTypeList">
                <div class="flex batch flex-between mt10 item-center">
                  <div class="ml10">
                    <el-button size="small" type="text" @click="batchSetting" disabled
                    >添加商品</el-button
                    >
                  </div>
                  <div class="flex flex-center">
                    <div @click="outputExcel" class="delete mr20 pointer">
                      <span class="delete-icon hmicon icon-daochu"></span>
                      导出模板
                    </div>
                    <div class="delete mr20 pointer open-file">
                      <span class="delete-icon hmicon icon-daoru"></span>
                      导入
                      <input
                              type="file"
                              @change="importf"
                              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                    </div>
                  </div>
                </div>
                <!-- <div class="flex batch flex-end mb10">
                  <div
                    @click="batchSetting"
                    class="pointer"
                    v-show="ruleForm.updateMode === 'yes'"
                  >
                    <span class="delete-icon hmicon icon-xitong"></span>
                    批量导入商品
                  </div>
                </div> -->
                <el-table
                        :data="rule"
                        row-key="wxshopSkuId"
                        border
                        stripe
                        style="width: 100%"
                        :header-cell-style="{
                    background: '#f7f7f7',
                    color: '#606266'
                  }"
                >
                  <el-table-column
                          type="index"
                          label="序号"
                          width="50"
                  ></el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="goodsSn"
                          label="商品货号"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                              class="item"
                              effect="dark"
                              :content="scope.row.goodsSn"
                              placement="top"
                              :disabled="!scope.row.goodsSn"
                      >
                        <el-input
                                disabled
                                clearable
                                style="width:120px"
                                @focus="inputChange"
                                v-model.trim="scope.row.goodsSn"
                                size="small"
                                placeholder="商品货号"
                        ></el-input>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="wxshopSpuName"
                          label="商品名称"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                              class="item"
                              effect="dark"
                              :content="scope.row.wxshopSpuName"
                              placement="top"
                              :disabled="!scope.row.wxshopSpuName"
                      >
                        <el-input
                                disabled
                                clearable
                                @focus="inputChange"
                                style="width:120px"
                                v-model.trim="scope.row.wxshopSpuName"
                                size="small"
                                placeholder="商品名称"
                        ></el-input>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="specIdGroupName"
                          label="商品规格"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                              class="item"
                              effect="dark"
                              :content="scope.row.specIdGroupName"
                              placement="top"
                              :disabled="!scope.row.specIdGroupName"
                      >
                        <div>
                          {{ scope.row.specIdGroupName }}
                        </div>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="eachPurchaseLimit"
                    label="单人限购"
                  >
                    <template slot-scope="scope">
                      <el-input
                        style="width:100px"
                        v-model.trim="scope.row.eachPurchaseLimit"
                        size="small"
                        @mousewheel.prevent.native
                        @input="
                          filterGt0OrFixed('eachPurchaseLimit', scope.$index)
                        "
                        clearable
                        placeholder="限购人数"
                      ></el-input>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="bargainTotalStockSum"
                          label="活动库存"
                  >
                    <template slot="header">
                      <el-tooltip
                              class="item"
                              effect="dark"
                              content="活动库存与商品总库存无关"
                              placement="top"
                      >
                        <div class="text-center primary">活动库存</div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <el-input
                              disabled
                              style="width:100px"
                              v-model.trim="scope.row.bargainTotalStockSum"
                              size="small"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed('bargainRemainStockSum', scope.$index)"
                              ref="dataVerification"
                              clearable
                              placeholder="活动库存"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="bargainRemainStockSum"
                          label="剩余库存"
                  >
                    <template slot-scope="scope">
                      <el-input
                              style="width:100px"
                              v-model.trim="scope.row.bargainRemainStockSum"
                              size="small"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed('bargainRemainStockSum', scope.$index)"
                              ref="dataVerification"
                              clearable
                              placeholder="活动库存"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="retailPrice"
                          label="零售价"
                  >
                    <template slot-scope="scope">
                      <el-input
                              disabled
                              clearable
                              style="width:100px"
                              @mousewheel.prevent.native
                              @input="filterGt0OrFixed2('retailPrice', scope.$index)"
                              v-model.trim="scope.row.retailPrice"
                              size="small"
                              placeholder="零售价"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="lowerLimitPrice"
                          label="底价"
                  >
                    <template slot="header">
                      <el-tooltip
                              class="item"
                              effect="dark"
                              content="商品砍到最后一人时的价格"
                              placement="top"
                      >
                        <div class="text-center primary">底价</div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <el-input
                              disabled
                              clearable
                              type="number"
                              style="width:100px"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed2('lowerLimitPrice', scope.$index)
                        "
                              v-model.trim="scope.row.lowerLimitPrice"
                              size="small"
                              placeholder="底价"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="eachBargainLowerLimit"
                          label="砍价最小值"
                          v-if="bargainType == 'amount'"
                  >
                    <template slot-scope="scope">
                      <el-input
                              disabled
                              clearable
                              type="number"
                              style="width:100px"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed2(
                            'eachBargainLowerLimit',
                            scope.$index
                          )
                        "
                              v-model.trim="scope.row.eachBargainLowerLimit"
                              size="small"
                              placeholder="最小值"
                      ></el-input
                      ></template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="eachBargainUpperLimit"
                          label="砍价最大值"
                          v-if="bargainType == 'amount'"
                  >
                    <template slot-scope="scope">
                      <el-input
                              disabled
                              clearable
                              type="number"
                              style="width:100px"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed2(
                            'eachBargainUpperLimit',
                            scope.$index
                          )
                        "
                              v-model.trim="scope.row.eachBargainUpperLimit"
                              size="small"
                              placeholder="最大值"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          align="center"
                          prop="bargainTotalNum"
                          label="需砍价人数"
                          v-if="bargainType == 'people'"
                  >
                    <template slot-scope="scope">
                      <el-input
                              disabled
                              clearable
                              type="number"
                              style="width:100px"
                              v-model.trim="scope.row.bargainTotalNum"
                              size="small"
                              @mousewheel.prevent.native
                              @input="
                          filterGt0OrFixed('bargainTotalNum', scope.$index)
                        "
                              placeholder="包括自己"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <!--el-table-column
                          header-align="center"
                          align="center"
                          label="操作"
                  >
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <div
                                v-if="scope.$index === 0"
                                class="add-wrapper flex flex-center"
                                style="marginLeft:0"
                        >
                          <span
                                  class="hmicon icon-hao pointer"
                                  @click="addChild(scope.$index)"
                          ></span>
                        </div>
                        <div
                                class="minus-wrapper flex flex-center"
                                style="marginLeft:0"
                                v-else
                        >
                          <span
                                  class="hmicon icon-jianhao pointer"
                                  @click="deleteChild(scope.$index)"
                          ></span>
                        </div>
                      </div>
                    </template>
                  </el-table-column-->
                </el-table>
                <!-- <div class="table game-select">
                  <div class="table-header flex">
                    <div class="flex-1 text-center">商品货号</div>
                    <div class="flex-1 text-center">商品名称</div>
                    <div class="flex-1 text-center">单人限购</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="活动库存与商品总库存无关"
                      placement="top"
                    >
                      <div class="flex-1 text-center primary">活动库存</div>
                    </el-tooltip>
                    <div class="flex-1 text-center">零售价</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="商品砍到最后一人时的价格"
                      placement="top"
                    >
                      <div class="flex-1 text-center primary">底价</div>
                    </el-tooltip>
                    <div
                      class="flex-1 text-center"
                      v-if="bargainType == 'amount'"
                    >
                      砍价最小值
                    </div>
                    <div
                      class="flex-1 text-center"
                      v-if="bargainType == 'amount'"
                    >
                      砍价最大值
                    </div>
                    <div
                      class="flex-1 text-center"
                      v-if="bargainType == 'people'"
                    >
                      需砍价人数
                    </div>
                    <div
                      class="flex-1 text-center"
                      v-show="ruleForm.updateMode === 'yes'"
                    >
                      操作
                    </div>
                  </div>
                  <div class="table-body">
                    <div
                      class="flex table-row item-center"
                      v-for="(item, index) in rule"
                      :key="index"
                    >
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          @focus="inputChange"
                          clearable
                          style="width:120px"
                          v-model.trim="item.goodsSn"
                          size="small"
                          placeholder="商品货号"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          @focus="inputChange"
                          clearable
                          style="width:120px"
                          v-model.trim="item.wxshopSpuName"
                          size="small"
                          placeholder="商品名称"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:100px"
                          v-model.trim="item.eachPurchaseLimit"
                          @mousewheel.prevent.native
                          @input="filterGt0OrFixed('eachPurchaseLimit', index)"
                          size="small"
                          clearable
                          placeholder="限购人数"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:100px"
                          v-model.trim="item.bargainTotalStockSum"
                          size="small"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed('bargainTotalStockSum', index)
                          "
                          clearable
                          placeholder="活动库存"
                        ></el-input>
                      </div>
                      <div class="flex-1 text-center">
                        <el-input
                          clearable
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:100px"
                          @mousewheel.prevent.native
                          @input="filterGt0OrFixed2('retailPrice', index)"
                          v-model.trim="item.retailPrice"
                          size="small"
                          placeholder="零售价"
                        ></el-input>
                      </div>

                      <div class="flex-1 text-center">
                        <el-input
                          clearable
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:100px"
                          v-model.trim="item.lowerLimitPrice"
                          @mousewheel.prevent.native
                          @input="filterGt0OrFixed2('lowerLimitPrice', index)"
                          size="small"
                          placeholder="底价"
                        ></el-input>
                      </div>
                      <div
                        class="flex-1 text-center"
                        v-if="bargainType == 'amount'"
                      >
                        <el-input
                          clearable
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:100px"
                          v-model.trim="item.eachBargainLowerLimit"
                          size="small"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2('eachBargainLowerLimit', index)
                          "
                          placeholder="最小值"
                        ></el-input>
                      </div>
                      <div
                        class="flex-1 text-center"
                        v-if="bargainType == 'amount'"
                      >
                        <el-input
                          clearable
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:100px"
                          v-model.trim="item.eachBargainUpperLimit"
                          size="small"
                          @mousewheel.prevent.native
                          @input="
                            filterGt0OrFixed2('eachBargainUpperLimit', index)
                          "
                          placeholder="最大值"
                        ></el-input>
                      </div>
                      <div
                        class="flex-1 text-center"
                        v-if="bargainType == 'people'"
                      >
                        <el-input
                          clearable
                          :disabled="ruleForm.updateMode === 'no'"
                          type="number"
                          style="width:140px"
                          v-model.trim="item.bargainTotalNum"
                          size="small"
                          @mousewheel.prevent.native
                          @input="filterGt0OrFixed('bargainTotalNum', index)"
                          placeholder="包括自己"
                        ></el-input>
                      </div>
                      <div
                        class="flex-1"
                        v-show="ruleForm.updateMode === 'yes'"
                      >
                        <div
                          class="add-wrapper flex flex-center"
                          v-if="index === 0"
                        >
                          <span
                            class="hmicon icon-hao pointer"
                            @click="addChild(index)"
                          ></span>
                        </div>
                        <div class="minus-wrapper flex flex-center" v-else>
                          <span
                            class="hmicon icon-jianhao pointer"
                            @click="deleteChild(index)"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
              </el-form-item>
               <div>
                   <div style="font-weight: bold;">砍价配置</div>
                 <div class="form-item-tip">
                    请配置砍价活动相关参数，注意同一时间段内只能开启一种砍价方式
                  </div>
                </div>

              <el-form-item label="是否开启消费砍价" prop="bargainByOrderState">
                  <el-switch
                    disabled
                    v-model="ruleForm.bargainByOrderState"
                    active-color="#13ce66"
                    inactive-color="#97a8be"
                    active-text="开启"
                    inactive-text="关闭"
                    active-value="yes"
                    inactive-value="no"
                  >
                  </el-switch>
                </el-form-item>
                  <el-form-item label="新会员注册砍价" prop="newUserRegistrationBargainEvent">
                  <el-switch
                   disabled
                    v-model="ruleForm.newUserRegistrationBargainEvent"
                    active-color="#13ce66"
                    inactive-color="#97a8be"
                    active-text="开启"
                    inactive-text="关闭"
                    active-value="yes"
                    inactive-value="no"
                  >
                  </el-switch>
                   <div class="form-item-tip">
                   开启后新注册会员可参与砍价活动
                  </div>
                   <div v-if="ruleForm.newUserRegistrationBargainEvent === 'yes'">
                  <span>新会员圈选条件：</span>
                   <el-input
                          disabled
                          style="width:100px"
                          v-model.trim="ruleForm.newUserDefaultDays"
                          size="small"
                          @mousewheel.prevent.native 
                          clearable
                          placeholder="请输入"
                        ></el-input>
                    <span>天内注册会员</span>    
                </div>
                </el-form-item>
                <el-form-item label="匹配订单时间" prop="matchOrderMode" v-if="ruleForm.bargainByOrderState==='yes' || ruleForm.newUserRegistrationBargainEvent==='yes'">
                  <el-radio-group
                    v-model="ruleForm.matchOrderMode"
                    size="small"
                    disabled
                  >
                    <el-radio label="today">当天订单</el-radio>
                    <el-radio label="range">时段订单</el-radio>
                  </el-radio-group>
                  <div class="form-item-tip">
                    选择当日订单情况下，在活动时间范围内当日订单当日兑换砍价次数，过期无效
                  </div>
                  <div v-if="ruleForm.matchOrderMode === 'range'">
                    <el-date-picker
                      disabled
                      :default-time="['00:00:00', '23:59:59']"
                      v-model="ruleForm.matchOrderDate"
                      type="datetimerange"
                      align="right"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      class="mr10"
                    ></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item
                  label="核销订单来源"
                  prop="orderSource"
                  v-if="ruleForm.bargainByOrderState==='yes' || ruleForm.newUserRegistrationBargainEvent==='yes'"
                >
                  <el-radio-group
                    disabled
                    v-model="ruleForm.orderSource"
                    size="small"
                  >
                    <el-radio label="online">线上</el-radio>
                    <!-- <el-radio label="offline">线下</el-radio> -->
                  </el-radio-group>
                  <div v-if="ruleForm.orderSource === 'online'">
                    <span class="title">目前只支持线上订单</span>
                  </div>
                  <!-- <div v-if="ruleForm.orderSource === 'offline'">
                    <span class="title">选择门店：</span>
                    <span class="form-item-tip">
                      (注：若不选择门店，则默认
                      <strong>不限制</strong>)
                    </span>
                    <div class="tip">
                      核销订单来源选择线下时，可选择门店，选择的对应门店的订单才可参与抽奖
                    </div>
                    <div>
                      <el-select
                        size="small"
                        multiple
                        filterable
                        clearable
                        placeholder="选择门店"
                        :disabled="type === 'detail'"
                        v-model="ruleForm.shopIds"
                        class="width-auto mr10"
                        style="width:300px"
                      >
                        <el-option
                          v-for="(item, i) in allShopList"
                          :key="i"
                          :label="item.shopName"
                          :value="item.shopId"
                        ></el-option>
                      </el-select>
                    </div>
                  </div> -->
                </el-form-item>
                <el-form-item
                  label="兑换门槛"
                  prop="orderSource"
                  v-if="ruleForm.bargainByOrderState==='yes' || ruleForm.newUserRegistrationBargainEvent==='yes'"
                >
                <div class="flex flex-wrap item-center">
                订单累计金额每满
                <el-input
                    disabled
                    type="number"
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.limitAmount"
                    placeholder="请输入数字"
                  ></el-input
                  >元，可额外获得一次砍价机会，兑换上限
                <el-input
                    disabled
                    type="number"
                    style="width: 100px"
                    size="small"
                    clearable
                    class="mr10 ipt"
                    v-model.trim="ruleForm.exchangeUpperLimit"
                    placeholder="请输入数字"
                  ></el-input
                  >次
                </div>
                </el-form-item>

              <div id="gameAstrict">
                {{ steps.length === 3 ? 3 : 3 }}活动限制
              </div>
              <el-form-item label="配送方式限制" prop="expressModeGroups">
                <el-checkbox-group v-model="ruleForm.expressModeGroups">
                  <div>
                    <el-checkbox label="shop_extract">门店自提</el-checkbox>
                    <el-select
                            class="ml10"
                            clearable
                            multiple
                            v-model="ruleForm.shopIds"
                            placeholder="请选择可销售门店"
                            size="small"
                            filterable
                            @change="getCheckedStore"
                            v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
                    >
                      <el-option
                              label="全部门店"
                              value="all"
                      ></el-option>
                      <el-option
                              :label="v.shopName"
                              :value="v.shopId"
                              v-for="(v, i) in microShopStoreList"
                              :key="i"
                      ></el-option>
                    </el-select>
                    <el-select
                        class="ml10"
                        clearable
                        multiple
                        v-model="ruleForm.shopIds"
                        placeholder="请选择可销售门店"
                        size="small"
                        filterable
                        @change="getCheckedStore"
                        v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
                    >
                      <el-option
                          label="全部门店"
                          value="all"
                      ></el-option>
                      <el-option
                          :label="v.shopName"
                          :value="v.shopId"
                          v-for="(v, i) in dkMicroShopStoreList"
                          :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-checkbox label="express_delivery">快递物流</el-checkbox>
                    <el-select
                            size="small"
                            v-model="ruleForm.expressId"
                            filterable
                            class="ml10"
                            clearable
                            placeholder="请选择运费模板"
                    >
                      <el-option
                              :label="v.expressName"
                              :value="v.expressId"
                              v-for="(v, i) in expressList"
                              :key="i"
                      ></el-option>
                    </el-select>
                  </div>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="扣减库存限制" prop="subStockType">
                <el-radio-group v-model="ruleForm.subStockType" disabled>
                  <el-radio label="createOrder">提交订单后扣减</el-radio>
                  <el-radio label="bargain">发起砍价后扣减</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="flex flex-center">
                <el-button
                        type="primary"
                        size="small"
                        @click="submitForm('ruleForm')"
                >确认</el-button
                >
                <el-button size="small" @click="$router.back(-1)"
                >返回</el-button
                >
              </div>
            </el-form>
          </div>
          <div class="text-center " style="width:120px">
            <el-button
                    class="fixed-but"
                    size="small"
                    type="danger"
                    round
                    @click="minimum"
                    v-if="isCollapse"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
            <el-button
                    v-else
                    class="fixed-but"
                    size="small"
                    type="primary"
                    round
                    @click="minimum"
            >
              <span class="hmicon icon-shouji"></span>
              <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
              <span class="hmicon icon-youshuangjiantou arrow"></span>
            </el-button>
          </div>
          <div class="pvws" v-show="!isCollapse">
            <img
                    style="width:100%"
                    src="https://imgcdn.hemiao100.com/ThemePictures/kanjia.png"
                    alt=""
            />
          </div>
        </div>
      </el-scrollbar>
      <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
        <div>
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据有误
          </div>
          <el-table :data="errInputResult" border class="small-table">
            <el-table-column
                    prop="goodsSn"
                    header-align="center"
                    align="center"
                    label="无效货号"
            ></el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="specBarcode"
                    label="无效条码"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <hm-filter-m-s-goods
              type="microShop"
              :visible="dialogVisible"
              :radio="isRadio"
              @saveGoods="saveGoods"
              @setLink="setLink"
              @close="dialogVisible = false"
      ></hm-filter-m-s-goods>
    </div>
  </hm-content>
</template>

<script>
  import HmStep from "@/components/HmStep";
  import myUpload from "vue-image-crop-upload";
  import HmRichEditor from "@/components/HmRichEditor";
  // import HmFilterMicroShopGoods from "@/components/HmFilterMicroShopGoods";
  import HmCountdown from "@/components/HmCountdown";
  import HmFilterMSGoods from "@/components/HmFilterMSGoods";
  import { arrayUnique2 } from "@/utils/utils";
  import { mapGetters } from "vuex";
  import XLSX from "xlsx";
  import {getLoginUser} from "@/utils/auth";
  let wb; // 读取完成的数据
  let rABS = false; // 是否将文件读取为二进制字符串
  export default {
    components: {
      HmStep,
      myUpload,
      HmRichEditor,
      HmFilterMSGoods,
      HmCountdown
    },
    data() {
      const expressModeGroupsStatus = (rule, val, callback) => {
        if (val.findIndex(v => v === "shop_extract") > -1) {
          if (!this.ruleForm.shopIds.length) {
            return callback(new Error("请选择可销售门店"));
          }
        }
        if (val.findIndex(v => v === "express_delivery") > -1) {
          if (!this.ruleForm.expressId) {
            return callback(new Error("请选择运费模板"));
          }
        }

        callback();
      };
      const profitmatchOrderMode = (rule, val, callback) => {
      if (val === "range") {
        if (this.ruleForm.matchOrderDate.length === 0) {
          return callback(new Error("请选择匹配订单时间段"));
        }
      }
      callback();
      };
      const patterndDrawTypeListFunc = function(rule, val, callback) {
        let flag = true;

        this.rule.map(v => {
          if (this.bargainType === "people") {
            if (
                    !v.goodsSn ||
                    !v.wxshopSpuName ||
                    !v.eachPurchaseLimit ||
                    !v.bargainTotalStockSum ||
                    !v.retailPrice ||
                    !v.bargainTotalNum
            ) {
              flag = false;
            }
          } else {
            if (
                    !v.goodsSn ||
                    !v.wxshopSpuName ||
                    !v.eachPurchaseLimit ||
                    !v.bargainTotalStockSum ||
                    !v.retailPrice ||
                    !v.eachBargainLowerLimit ||
                    !v.eachBargainUpperLimit
            ) {
              flag = false;
            }
            if(v.bargainTotalStockSum <= 0){
              flag = false;
            }
          }
        });

        if (flag) {
          callback();
        } else {
          return callback(new Error("请填写所有项,并输入正整数！"));
        }
      }.bind(this);
      const actDate = function(rule, val, callback) {
        // if (val > +this.ruleForm.actMemberUpperLimit) {
        //   return callback(new Error("已报名人数不能大于活动人数上限"));
        // }

        if (!this.ruleForm.activityDate.length > 0) {
          return callback(new Error("请选择活动时间段"));
        }

        callback();
      }.bind(this);
      const patterndMainImgUrlFunc = function(rule, val, callback) {
        if (!this.listHeaderImgUrl) {
          return callback(new Error("请选择主图"));
        }
        callback();
      }.bind(this);
      return {
        selectOther: false,
        selectAll: false,
        expressList: [],
        errValidGoods: false,
        errInputResult: [],
        pickerOptions: {
          disabledDate(time) {
            let curDate = new Date().getTime();
            // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
            let day = 365 * 24 * 3600 * 1000;
            let dateRegion = curDate + day;
            return (
                    time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
            );
          }
        },
        endTime: "2019-11-11 18:12:00",
        type: false,
        isRadio: false,
        listHeaderImgUrl: "",
        storeId: "",
        currentStep: 1,
        scrollHeight: 0,
        show: false,
        dialogVisible: false,
        steps: [
          {
            id: "base",
            name: "基本信息"
          },
          {
            id: "gameRule",
            name: "活动规则"
          },
          {
            id: "gameAstrict",
            name: "活动限制"
          }
        ],
        storeCode: "",
        ruleForm: {
          activityDate: [],
          gameName: "",
          gameRuleRemark: "",
          gameShareContent: "",
          gameBgm: "",
          visualJoinNum: "0",
          subStockType: "createOrder",
          expressModeGroups: [],
          shopIds: [],
          expressId: "",
          matchOrderMode:"today",
          matchOrderDate: [],
          orderSource:"online",
          bargainByOrderState:"yes",
          newUserRegistrationBargainEvent:'no',
          newUserDefaultDays:'',
          limitAmount:"",
          exchangeUpperLimit:"",
          sharePic: "",
        },
        screening: "",
        bargainType: "people",
        rule: [
          {
            goodsSn: "",
            wxshopSpuName: "",
            eachPurchaseLimit: "1",
            bargainTotalStockSum: "",
            bargainRemainStockSum:'',
            retailPrice: "",
            lowerLimitPrice: "",
            bargainTotalNum: "",
            eachBargainLowerLimit: "",
            eachBargainUpperLimit: ""
          }
        ],
        threshold: {
          expressModeGroup: []
        },
        rules: {
          bargainTotalStockSum:[
            {
              pattern: /^[0-9]\d*$/,
              message: "请输入正整数",
              trigger: "blur"
            },
            {
              required: true,
              message: "请输入剩余库存",
              trigger: "blur"
            }
          ],
          visualJoinNum: [
            {
              pattern: /^[0-9]\d*$/,
              message: "请输入正整数",
              trigger: "blur"
            },
            {
              required: true,
              message: "请输入虚拟参与人数",
              trigger: "blur"
            }
          ],
          gameName: [
            {
              required: true,
              message: "请输入活动标题",
              trigger: "blur"
            },
            { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
          ],
          gameShareContent: [
            {
              required: true,
              message: "请输入活动分享文案",
              trigger: "blur"
            }
          ],
          mainImgUrl: [
            {
              required: true,
              validator: patterndMainImgUrlFunc,
              trigger: "blur"
            }
          ],
          gameRuleRemark: [
            {
              required: true,
              message: "请输入活动规则说明",
              trigger: "blur"
            }
          ],
          activityDate: {
            required: true,
            validator: actDate,
            trigger: "blur"
          },
          drawTypeList: [
            {
              required: true,
              validator: patterndDrawTypeListFunc,
              trigger: "blur"
            }
          ],
          expressModeGroups: [
            {
              required: true,
              message: "请选择配送方式限制"
            },
            {
              required: true,
              validator: expressModeGroupsStatus
            }
          ],
          subStockType: [
            {
              required: true,
              message: "请选择扣减库存限制",
              trigger: "blur"
            }
          ],
          matchOrderMode: {
            required: true,
            validator: profitmatchOrderMode,
            trigger: "blur"
          },
          orderSource: {
            required: true,
            message: "请选择核销订单来源",
            trigger: "change"
          },
          bargainByOrderState:{
            required: true,
            message: "请选择是否开启消费砍价",
            trigger: "change"
          }
        },
        options: [
          {
            value: "1",
            label: "1"
          }
        ],
        actDesc: {},
        sole: Boolean,
        isCollapse: true,
        isSaving: false,
        uploadShow: true,
      };
    },
    computed: mapGetters(["microShopStoreList", "dkMicroShopStoreList"]),
    watch: {},
    created() {
      this.queryExpressList();
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll, true);
      window.addEventListener("resize", this.handleResize, true);
      this.calcHeight();
      const { storeCode } = getLoginUser();
      this.storeCode = storeCode;
      console.log("this.storeCode:",this.storeCode);
      if (storeCode === '42010216070190' || storeCode === '53010017032439') {
        this.$store.dispatch("queryDkMicroStoreList");
      } else {
        this.$store.dispatch("queryMicroStoreList");
      }
      this.activityDetail().then(res => {
        for (let key in res.result) {
          this.ruleForm[key] = res.result[key];
        }

        this.ruleForm.activityDate = [
          res.result.gameStartTime,
          res.result.gameEndTime
        ];
        this.listHeaderImgUrl = res.result.gameBgp;
        this.ruleForm.sharePic = res.result.gameBgp2;
        this.rule = res.result.rule;
        this.bargainType = res.result.rule[0].bargainType;
        this.threshold = res.result.threshold;
      });
    },
    destroyed: function() {
      window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
      window.removeEventListener("resize", this.handleResize);
    },
    methods: {
      verification(row){
        if(row <= 0 ){
          this.$message({
            message: "剩余奖品不能小于或等于0！",
            type: "warning"
          });
          this.$refs.dataVerification.focus();
        }
      },
      // 运费模板
      async queryExpressList() {
        const { result } = await this.$store.dispatch("storeExpressConfigList");
        this.expressList = [];
        if (result.defaultTemplate) {
          this.expressList.push(result.defaultTemplate);
        }
        this.expressList.push(...result.templateList);
      },
      getCheckedStore(storeList) {
        this.selectOther = storeList.findIndex(o => o !== "all") > -1;
        this.selectAll = storeList.findIndex(o => o === "all") > -1;
        if (this.selectAll) {
          this.ruleForm.shopIds = ["all"];
        }
      },
      // 导出excel
      outputExcel() {
        require.ensure([], () => {
          const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
          const tHeader = ["商品货号", "商品条码"];
          const filterVal = [];
          const data = this.formatJson(filterVal, []);
          exportJsonToExcel(tHeader, data, "导入模板");
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
      // 导入excel
      importf(e) {
        const obj = e.target;
        const that = this;
        this.inputData = [];
        if (!obj.files) {
          return;
        }
        let f = obj.files[0];
        let reader = new FileReader();
        reader.onload = function(e) {
          let data = e.target.result;
          if (rABS) {
            wb = XLSX.read(btoa(this.fixdata(data)), {
              // 手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(data, {
              type: "binary"
            });
          }
          let result = null;
          wb.SheetNames.forEach(sheetName => {
            let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
              header: 1
            });
            if (roa.length) {
              result = roa.slice(1);
            }
          });

          let goodsSnsAndSpecBarcode = [];
          result.forEach(v => {
            // if (v[0]) {
            //   goodsSns.push(v[0]);
            // }
            if (v[0] || v[1]) {
              goodsSnsAndSpecBarcode.push({
                goodsSn: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                specBarcode: v[1] ? (v[1] + "").replace(/\s*/g, "") : ""
              });
            }
          });

          // goodsSns = unique(goodsSns);
          that.$store
                  .dispatch("queryWxshopSkuByGoodsSn", { goodsSnsAndSpecBarcode })
                  .then(res => {
                    const { code, result } = res;
                    if (code === "0") {
                      if (result.modelList.length > 0) {
                        result.modelList.forEach(v => {
                          v.bargainTotalStockSum = "";
                          v.eachPurchaseLimit = "1";
                          v.integralValue = "";
                        });
                        that.rule.push(...result.modelList);
                        that.rule = arrayUnique2(that.rule, "wxshopSkuId");
                        that.$forceUpdate();
                      }
                      if (result.errGoodsSnsAndSpecBarcode.length > 0) {
                        that.errValidGoods = true;
                        that.errInputResult = result.errGoodsSnsAndSpecBarcode;
                      }
                    }
                  });
        };
        if (rABS) {
          reader.readAsArrayBuffer(f);
        } else {
          reader.readAsBinaryString(f);
        }
        obj.value = "";
      },
      isString(value) {
        return typeof value === "string";
      },
      fixdata(data) {
        // 文件流转BinaryString
        let o = "";
        let l = 0;
        let w = 10240;
        for (; l < data.byteLength / w; ++l)
          o += String.fromCharCode.apply(
                  null,
                  new Uint8Array(data.slice(l * w, l * w + w))
          );
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
        return o;
      },
      activityDetail() {
        const { gameId } = this.$route.query;
        const params = {
          gameId
        };
        return this.$store.dispatch("queryActivitDetail", params);
      },
      cropSuccess() {},
      cropUploadFail() {},
      cropUploadSuccess(jsonData) {
        if (this.show) {
          this.listHeaderImgUrl = jsonData.result;
        } else if (this.showDetail) {
          this.uploadedDetailList.push(jsonData.result);
        }
      },
      filterGt0OrFixed(prop, i) {
        this.rule[i][prop] = this.rule[i][prop].replace(/^(0+)/, ""); //过滤0开头
        this.rule[i][prop] = this.rule[i][prop].replace(/[^\d]/g, ""); //仅保留数字
        this.rule[i][prop] = this.rule[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
        this.rule[i][prop] = this.rule[i][prop]
                .replace(".", "$#*")
                .replace(/\./g, "")
                .replace("$#*", "."); //去除其他"."
        this.rule[i][prop] = this.rule[i][prop].replace(
                /^(\d+)\.(\d\d).*$/,
                "$1.$2"
        ); //限制只能输入两个小数
        if (this.rule[i][prop].indexOf(".") < 0 && this.rule[i][prop] != "") {
          //首位是0的话去掉
          this.rule[i][prop] = parseFloat(this.rule[i][prop]);
        }
      },
      filterGt0OrFixed2(prop, i) {
        // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
        this.rule[i][prop] = this.rule[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
        this.rule[i][prop] = this.rule[i][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.rule[i][prop] = this.rule[i][prop]
                .replace(".", "$#*")
                .replace(/\./g, "")
                .replace("$#*", "."); //去除其他"."
        this.rule[i][prop] = this.rule[i][prop].replace(
                /^(\d+)\.(\d\d).*$/,
                "$1.$2"
        ); //限制只能输入两个小数
        if (this.rule[i][prop].indexOf(".") < 0 && this.rule[i][prop] != "") {
          //首位是0的话去掉
          this.rule[i][prop] = parseFloat(this.rule[i][prop]);
        }
      },
      windowScroll(i) {
        this.$nextTick(() => {
          document.getElementById(this.steps[i].id).scrollIntoView();
          this.currentStep = i + 1;
        });
      },
      toggleShow() {
        this.show = !this.show;
      },
      handleResize() {
        this.calcHeight();
      },
      calcHeight() {
        setTimeout(() => {
          const headerHeight = document.querySelector(".navbar")
                  ? document.querySelector(".navbar").getBoundingClientRect().y
                  : 0;
          const tagHeight = document.querySelector(".tags-view-container")
                  ? document
                          .querySelector(".tags-view-container")
                          .getBoundingClientRect().y
                  : 0;
          const stepsHeight = document.querySelector(".step-wrapper")
                  ? document.querySelector(".step-wrapper").getBoundingClientRect().y
                  : 0;
          const footerHeight = document.querySelector(".el-footer")
                  ? document.querySelector(".el-footer").getBoundingClientRect().height
                  : 0;
          this.scrollHeight =
                  window.innerHeight -
                  headerHeight -
                  tagHeight -
                  stepsHeight -
                  footerHeight -
                  80;
        }, 0);
      },
      handleScroll(e) {
        this.steps.map((v, i) => {
          const ele = document.getElementById(v.id);
          if (ele) {
            const offsetTop = ele.offsetTop;
            if (e.target.scrollTop + 360 > offsetTop) {
              this.currentStep = i + 1;
            } else {
              this.currentStep = i - 1;
            }
          }
        });
      },
      addChild() {
        this.rule.push({
          goodsSn: "",
          wxshopSpuName: "",
          eachPurchaseLimit: "1",
          bargainTotalStockSum: "",
          retailPrice: "",
          lowerLimitPrice: "",
          bargainTotalNum: "",
          eachBargainLowerLimit: "",
          eachBargainUpperLimit: ""
        });
      },
      deleteChild(index) {
        this.rule.splice(index, 1);
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.ruleForm.gameStartTime =
                    this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
                            ? this.ruleForm.activityDate[0]
                            : "";
            this.ruleForm.gameEndTime =
                    this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
                            ? this.ruleForm.activityDate[1]
                            : "";

            // this.rule.seckillRuleList.forEach((v, i) => {
            //   v.roundSeqNum = i + 1;
            //   v.roundStartTime =
            //     v.activityDate && v.activityDate.length > 0
            //       ? v.activityDate[0]
            //       : "";
            //   v.roundEndTime =
            //     v.activityDate && v.activityDate.length > 0
            //       ? v.activityDate[1]
            //       : "";
            // });
            this.rule.forEach(v => {
              v.bargainType = this.bargainType;
            });

            let params = this.ruleForm;
            params.gameType = "bargain";
            params.gameBgp = this.listHeaderImgUrl;
            params.gameBgp2 = this.ruleForm.sharePic;
            //   if (this.rule.drawType == "daily") {
            //     this.rule.drawPrizeNum = this.rule.drawPrizeNumDaily;
            //     this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitDaily;
            //   } else {
            //     this.rule.drawPrizeNum = this.rule.drawPrizeNumTotal;
            //     this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitTotal;
            //   }

            params = Object.assign(params, {
              rule: this.rule,
              threshold: this.threshold,
              gameId: this.$route.query.gameId,
              isLook:'yes'
            });

            this.$store.dispatch("editActivity", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          } else {
            return false;
          }
        });
      },
      handleRemove() {
        this.listHeaderImgUrl = "";
      },
      sample() {
        this.dialogVisible = true;
      },
      saveGoods(data) {
        if (data.length > 0) {
          this.dialogVisible = false;
          data.forEach(v => {
            this.$set(v, "retailPrice", v.showPrice);
            this.$set(v, "bargainTotalStockSum", v.stockNum);
            // this.$set(v, "roundSeqNumGroupArray", []);
            // v.retailPrice = v.showPrice;

            // v.bargainTotalStockSum = v.stockNum;
            v.roundSeqNumGroupArray = [];
            v.eachPurchaseLimit = "1";
          });
          if (this.rule.length === 1) {
            this.rule = [];
          }
          if (this.sole) {
            this.rule.splice(this.rule.length - 1, 1);
          }
          this.rule.push(...data);
        } else {
          this.$message({
            message: "请选择商品",
            type: "warning"
          });
        }
      },
      setLink(row) {
        // if (this.currentLinkIndex !== -1) {
        //   this.currentProp[this.currentLinkPropName][
        //     this.currentLinkIndex
        //   ].goodsInfo = row;
        //   this.currentProp[this.currentLinkPropName][
        //     this.currentLinkIndex
        //   ].hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
        // } else {
        //   this.currentProp.goodsInfo = row;
        //   this.currentProp.hrefAddress = `/pages/product/product?wxshopSpuId=${row.wxshopSpuId}`;
        // }
        this.dialogVisible = false;
        this.isRadio = false;
      },
      batchSetting() {
        this.dialogVisible = true;
      },
      inputChange() {
        this.dialogVisible = true;
        this.sole = true;
      },
      minimum() {
        this.isCollapse = !this.isCollapse;
      },
      beforeUpload(file) {
        const extension =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
            "jpg" ||
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
        const extension2 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpeg";
        const extension3 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
        const extension4 =
          file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
        // file.size单位为b，除以1024得到kb
        const limitSize = file.size / 1024 <= 1020;
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
            type: "warning"
          });
        }
        if (!limitSize) {
          this.$message({
            message: "上传模板大小不能超过 1M!",
            type: "warning"
          });
        }
        return (extension || extension2 || extension3 || extension4) && limitSize;
      },
      uploadSharePicSucc(jsonData){
        if (jsonData.code === 0) {
          this.ruleForm.sharePic = jsonData.result;
          this.uploadShow = false;
        }
      },
      // 正在上传
      uploading() {
        this.isSaving = true;
        this.uploadShow = true;
      },
      handleRemoveSharePic(){
        this.ruleForm.sharePic = "";
      },
    }
  };
</script>
<style lang="scss">
  .game-select {
    .el-select {
      width: 140px !important;
      .el-input {
        width: 140px !important;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .fixed-but {
    position: fixed;
    top: 150px;
    right: 20px;
  }
  .pvw {
    .pvws {
      width: 350px;
      margin-right: 100px;
      position: relative;
      position: fixed;
      right: 0;
      .commodityImg {
        width: 150px;
        height: 100px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .actcontent {
        width: 161px;
        height: 100px;
        margin-left: 20px;
        .activityTitle {
          font-size: 20px;
          font-weight: 600;
          margin-top: -1px;
        }
        .activityPrice {
          font-size: 24px;
          color: #ff563a;
          font-weight: 600;
        }
        .originalCost {
          color: #919191;
        }
      }

      .hr {
        height: 10px;
        background-color: #f7f7f7;
      }
      .pvwimg {
        width: 100%;
        height: 100%;
        // position: relative;
      }
      .describe {
        width: 100%;
        color: #ffffff;
        font-size: 17px;
        position: absolute;
        left: 50%;
        margin-left: -50%;
        top: 248px;
      }
    }
    #audio_btn {
      position: absolute;
      left: 10px;
      top: 70px;
      z-index: 999999;
      width: 45px;
      height: 45px;
      background-image: url("https://imgcdn.hemiao100.com/hemiaoBase/ico_music.png");
      background-size: contain;
      background-repeat: no-repeat;
    }
    .rotate {
      -webkit-animation: rotating 1.2s linear infinite;
      -moz-animation: rotating 1.2s linear infinite;
      -o-animation: rotating 1.2s linear infinite;
      animation: rotating 1.2s linear infinite;
    }
  }
  .table {
    border: 1px solid #ddd;
    .table-header {
      padding: 16px 0;
      background: #f7f7f7;
      font-size: 14px;
      font-weight: bold;
    }
    .table-row {
      padding: 5px 0;
      font-size: 14px;
    }
    .table-row:nth-child(even) {
      background: #f7f7f7;
    }
    .add-wrapper,
    .minus-wrapper {
      margin: 0 auto;
    }
  }
  .priview {
    position: relative;
    width: 400px;
    height: 234px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    img {
      width: 100%;
      height: 100%;
    }
    .opreat-wrapper {
      transition: opacity 0.2s linear;
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 6px;
    }

    &:hover {
      .opreat-wrapper {
        opacity: 1;
      }
    }
  }
</style>

